<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-text-area formControlName="code" formField required [label]="'common.code' | translate | ucfirst"></dx-text-area>
  <dx-text-area formControlName="name" formField required [label]="'common.name' | translate | ucfirst"></dx-text-area>
</form>